module.exports = __webpack_public_path__ + "static/media/formats_xls.fabcdd23.svg";